import React from 'react';
import { FlameIcon } from 'lucide-react';
const SPOTS_LEFT = 7;
const FILLED_PERCENT = 93;
export function ScarcityBar() {
  return <div className="mt-8 rounded-2xl bg-gum-light p-5 text-left" data-id="element-321" data-mp="2yvt76lzgnhwq">
      <p className="flex items-center gap-2 text-[15px] font-extrabold text-gum" data-id="element-322" data-mp="2l5pna1o200ag">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-323" data-mp="2q3r4si5tzrjt" />
        Only {SPOTS_LEFT} spots left at the promotional price!
      </p>
      <div className="relative mt-3 h-5 w-full overflow-hidden rounded-full bg-white ring-1 ring-gum/20" role="progressbar" aria-valuenow={FILLED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-324" data-mp="2b56x6p5wbnk3">
        <div className="relative h-full overflow-hidden rounded-full bg-gum" style={{
        width: `${FILLED_PERCENT}%`
      }} data-id="element-325" data-mp="275y47miojtpl">
          <span className="animate-bar-shine absolute inset-y-0 left-0 w-1/3 bg-white/25" aria-hidden="true" data-id="element-326" data-mp="fgs2cdcly5u" />
        </div>
      </div>
      <p className="mt-2 flex justify-between text-xs font-semibold text-ink/70" data-id="element-327" data-mp="33mv6yjuohb5q">
        <span data-id="element-328" data-mp="33kigtjernuhl">{FILLED_PERCENT}% claimed</span>
        <span data-id="element-329" data-mp="2zm2uziuf8s5r">Price increases when spots run out</span>
      </p>
    </div>;
}